import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pricing from "@/components/Pricing";
import Process from "@/components/Process";
import Equipment from "@/components/Equipment";
import Booking from "@/components/Booking";
import Reviews from "@/components/Reviews";
import Services from "@/components/Services";
import BookItIn from "@/components/BookItIn";
import Footer from "@/components/Footer";
import StickyCta from "@/components/StickyCta";

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, anchors: true }}>
      <div className="min-h-screen overflow-x-clip bg-[#09090b] font-sans text-white">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Pricing />
          <Process />
          <Equipment />
          <Booking />
          <Reviews />
          <Services />
          <BookItIn />
        </main>
        <Footer />
        <StickyCta />
        <Toaster position="top-center" theme="dark" />
      </div>
    </ReactLenis>
  );
}
